import type { CSSProperties } from 'react';
import { forwardRef } from 'react';

import type { StackProps, Theme } from '@mui/material';
import { CircularProgress, Stack } from '@mui/material';

import { CONTENT_PAGE_HEIGHT } from 'app/AppConstants';

type PageProps = StackProps & {
  color?: 'white' | 'inherit' | string;
  loading?: boolean;
};

export const Page = forwardRef<HTMLDivElement, PageProps>(
  ({ id, color = 'inherit', children, loading, overflow, height, width, sx, ...props }, ref) => {
    return (
      <Stack
        id={id ?? 'page'}
        sx={(theme: Theme) =>
          ({
            flex: 1,

            height: height ?? CONTENT_PAGE_HEIGHT,
            width: width ?? 1,

            ...(loading && {
              position: 'absolute',

              alignItems: 'center',
              justifyContent: 'center',

              top: 0,
              left: 0,
              height: 1,
              width: 1
            }),

            backgroundColor: color === 'white' ? theme.palette.common.white : color,

            overflow: (overflow ?? color === 'white') ? 'hidden' : 'inherit',

            ...(typeof sx === 'function' ? sx(theme) : sx)
          }) as CSSProperties
        }
        {...props}
        ref={ref}
      >
        {loading ? <CircularProgress /> : children}
      </Stack>
    );
  }
);

Page.displayName = 'Page';
